import { useState, useEffect } from "react";
import "./Pagination.css";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

const Pagination = ({
  showPerPage,
  total,
  onPaginationChange,
  currentPage: controlledCurrentPage,
  itemsPerPage: controlledItemsPerPage,
  totalPages: controlledTotalPages,
  className = "",
}) => {
  const [currentPage, setCurrentPage] = useState(controlledCurrentPage || 1);
  const [itemsPerPage, setItemsPerPage] = useState(
    controlledItemsPerPage || showPerPage
  );
  const isPageControlled = controlledCurrentPage !== undefined;
  const isItemsPerPageControlled = controlledItemsPerPage !== undefined;
  const activeCurrentPage = isPageControlled ? controlledCurrentPage : currentPage;
  const activeItemsPerPage = isItemsPerPageControlled
    ? controlledItemsPerPage
    : itemsPerPage;

  useEffect(() => {
    if (controlledCurrentPage) {
      setCurrentPage(controlledCurrentPage);
    }
  }, [controlledCurrentPage]);

  useEffect(() => {
    if (controlledItemsPerPage) {
      setItemsPerPage(controlledItemsPerPage);
    }
  }, [controlledItemsPerPage]);

  // ✅ define totalPages here
  const totalPages =
    controlledTotalPages ||
    Math.max(1, Math.ceil((total || 0) / (activeItemsPerPage || 1)));

  const onButtonClick = (type) => {
    const nextPage =
      type === "prev"
        ? Math.max(1, activeCurrentPage - 1)
        : Math.min(totalPages, activeCurrentPage + 1);

    if (!isPageControlled) {
      setCurrentPage(nextPage);
    }

    onPaginationChange(nextPage, activeItemsPerPage);
  };

  const handleItemsPerPageChange = (e) => {
    const newItemsPerPage = Number(e.target.value);
    if (!isItemsPerPageControlled) {
      setItemsPerPage(newItemsPerPage);
    }
    if (!isPageControlled) {
      setCurrentPage(1);
    }
    onPaginationChange(1, newItemsPerPage);
  };

  return (
    <div className={`paginations ${className}`.trim()}>
      <div className="pagination-body">
        <div className="pagination-left-side">
          <div className="page-range">
            Page {total > 0 ? activeCurrentPage : 0} of {total > 0 ? totalPages : 0},
            Total: <strong>{total}</strong> Items
          </div>
        </div>
        <div className="pagination-right-side">
          <div className="arrow-number">
            <button
              className="arrow arrow2"
              onClick={() => onButtonClick("prev")}
              disabled={activeCurrentPage === 1}
            >
              <IoIosArrowBack />
            </button>
            <button
              className="arrow arrow3"
              onClick={() => onButtonClick("next")}
              disabled={activeCurrentPage === totalPages}
            >
              <IoIosArrowForward />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Pagination;
